import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { changeVoteDirection } from '../../../api/comments';

import { REQUEST } from '../../../constants/request';
import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeCommentWithUserData } from '../../../utils/comments';

export const changeVoteComment = createAsyncThunk(
  'comments/changeVoteComment',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentResponse, userdataResponse] = await changeVoteDirection(
        commentData,
        {
          cancelToken: source.token,
        },
      );
      return mergeCommentWithUserData(commentResponse, userdataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const { comments } = getState().comments;
      const commentCIDKey = generateCommentCIDKey(path);

      return (
        comments.comment.actions.commentsVote.request[commentCIDKey]
          ?.loading !== REQUEST.pending
      );
    },
  },
);

export const changeVoteCommentExtraReducers = builder => {
  builder
    .addCase(changeVoteComment.pending, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(
        state.comments.comment.actions.commentsVote.request,
        action,
        commentCIDKey,
      );
    })
    .addCase(changeVoteComment.fulfilled, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.comments.comment.actions.commentsVote.request[commentCIDKey],
        action,
        () => {
          state.comments.comment.byId[commentCIDKey] = action.payload;
          if (!state.comments.comment.allIds.includes(commentCIDKey)) {
            state.comments.comment.allIds.push(commentCIDKey);
          }
        },
      );
    })
    .addCase(changeVoteComment.rejected, (state, action) => {
      const commentCIDKey = generateCommentCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.comments.comment.actions.commentsVote.request[commentCIDKey],
        action,
      );
    });
};
